import "./styles/global.css";

export function App() {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 rounded-lg bg-indigo-600" />
          <span className="text-lg font-semibold tracking-tight">Client Portal</span>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center p-12">
        <div className="text-center">
          <h1 className="text-3xl font-bold tracking-tight">Phase 0 Skeleton</h1>
          <p className="mt-2 text-gray-500">
            The client-facing portal shell. Authentication and views are implemented in Phase 2.
          </p>
        </div>
      </main>
    </div>
  );
}
